import { Box } from '@mui/material';
import styled from 'styled-components';

export const Container = styled(Box)`
  background: #fff;
  border-radius: 10px;
`;
